import React, { useState } from "react";
import classNames from "classnames";
import classes from "./pagination.module.css";

const NewPagination = ({ paginatedData, onPageSelect, currentPage }) => {
  const pageRange = 6;
  const { first_page_url, last_page_url, pages = [] } = paginatedData;
  const totalPages = pages.length;
  const totalPagesRange = Math.ceil(totalPages / pageRange);
  const currentPageRange = Math.ceil(currentPage / pageRange);

  const showPreviousButton = currentPage > 1;
  const showNextButton = currentPage < totalPages;

  const handlePreviousButtonClick = e => {
    e.preventDefault();
    let lastPage;
    for (let i = 0; i < pages.length; ++i) {
      const page = pages[i];
      if (page.is_active) {
        lastPage = pages[i - 1];
        break;
      }
    }
    onPageSelect(lastPage);
  };

  const handleNextButtonClick = e => {
    e.preventDefault();
    let nextPage;
    for (let i = 0; i < pages.length; ++i) {
      const page = pages[i];
      if (page.is_active) {
        nextPage = pages[i + 1];
        break;
      }
    }
    onPageSelect(nextPage);
  };

  const renderPage = p => {
    return (
      <div
        key={p.page}
        className={classNames(
          classes.page,
          p.is_active ? classes.activePage : classes.link
        )}
        onClick={() => onPageSelect(p)}
      >
        {p.page}
      </div>
    );
  };

  const renderPages = () => {
    let startIndex = (currentPageRange - 1) * pageRange;
    if (currentPage >= pageRange)
      startIndex = Number(currentPage) + 2 - pageRange;
    const endIndex = Math.min(
      startIndex + pageRange,
      totalPages < pageRange ? totalPages : totalPages - 1,
      totalPages === Number(currentPage) && totalPages > pageRange
        ? totalPages - 2
        : totalPages
    );
    const visiblePages = pages.slice(startIndex, endIndex);
    return visiblePages.map(renderPage);
  };

  return (
    <div className={classes.paginationContainer}>
      {showPreviousButton ? (
        <button className={classes.button} onClick={handlePreviousButtonClick}>
          <img
            src="/hire/pagination-arrow.svg"
            alt="page-arrow-left"
            className={classNames(classes.arrow, classes.leftArrow)}
            width={8}
            height={8}
          />
        </button>
      ) : null}
      <div className={classes.pagesContainer}>
        {first_page_url && currentPage > 1 ? (
          <>
            {renderPage(first_page_url)}
            <div key="first-ellipsis" className={classes.ellipses}>
              ...
            </div>
          </>
        ) : null}
        {renderPages()}
        {last_page_url && pageRange < pages.length - 1 ? (
          <>
            <div key="last-ellipsis" className={classes.ellipses}>
              ...
            </div>
            {totalPages === Number(currentPage) &&
              totalPages > pageRange &&
              renderPage(pages[currentPage - 2])}
            {renderPage(last_page_url)}
          </>
        ) : null}
      </div>
      {showNextButton ? (
        <button className={classes.button} onClick={handleNextButtonClick}>
          <img
            src="/hire/pagination-arrow.svg"
            alt="page-arrow-right"
            width={10}
            height={10}
            className={classes.arrow}
          />
        </button>
      ) : null}
    </div>
  );
};

export default NewPagination;
